import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GoogleMap, MapMarker } from '@angular/google-maps';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../misc.module';
import { MapViewPageRoutingModule } from './map-view-routing.module';
import { MapViewPageComponent } from './map-view.page';

@NgModule({
  declarations: [MapViewPageComponent],
  imports: [FormsModule, IonicModule, MapViewPageRoutingModule, MiscModule, CommonModule, GoogleMap, MapMarker]
})
export class MapViewPageModule {}
